import { jwtDecode } from "jwt-decode";
import { TOKEN_CONFIG } from "../constants";

/**
 * Check if JWT token is expired or about to expire
 * @param token - JWT token string
 * @param bufferTime - Minutes before expiration to consider token as "about to expire" (default: 0)
 * @returns 
 *   - "expiredYesterday": Token expired more than 24 hours ago (yesterday or earlier)
 *   - true: Token is expired or will expire within bufferTime minutes
 *   - false: Token is valid and not expiring soon
 */
export const isTokenExpired = (
  token: string,
  bufferTime: number = 0
): "expiredYesterday" | boolean => {
  if (!token) return true;

  try {
    const payload = jwtDecode(token);
    const exp = (payload.exp ?? 0) * 1000; // convert to ms
    const now = Date.now();
    const timeLeft = exp - now;

    // If token expired more than 24 hours ago, return special value
    if (timeLeft < -TOKEN_CONFIG.TWENTY_FOUR_HOURS_MS) {
      return "expiredYesterday";
    }

    // Return true if token is already expired
    if (timeLeft <= 0) {
      return true;
    }

    // Check if the token will expire within the buffer time (in minutes)
    const bufferTimeMs = bufferTime * 60 * 1000;
    return timeLeft < bufferTimeMs;
  } catch (error) {
    console.error("Invalid token:", error);
    return true;
  }
};
